import { render, staticRenderFns } from "./DeactivatedUsersTable.vue?vue&type=template&id=03147687"
import script from "./DeactivatedUsersTable.vue?vue&type=script&lang=js"
export * from "./DeactivatedUsersTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports